"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _component = require("../component");

var _Checkbox = _interopRequireDefault(require("../Checkbox/Checkbox"));

var _styles = require("../styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(_default, _PureComponent);

  function _default(props) {
    var _this;

    _this = _PureComponent.call(this, props) || this;
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    props.datum.bind(props.id, _this.forceUpdate.bind(_assertThisInitialized(_assertThisInitialized(_this))));
    return _this;
  }

  var _proto = _default.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    _PureComponent.prototype.componentWillUnmount.call(this);

    this.props.datum.unbind(this.props.id);
  };

  _proto.checkDisabled = function checkDisabled() {
    var _this$props = this.props,
        datum = _this$props.datum,
        id = _this$props.id,
        disabled = _this$props.disabled;
    if (disabled) return true;
    return datum.isDisabled(id);
  };

  _proto.handleChange = function handleChange(v, checked) {
    var _this$props2 = this.props,
        datum = _this$props2.datum,
        id = _this$props2.id,
        onChange = _this$props2.onChange;
    datum.set(id, checked ? 1 : 0);
    onChange(datum.getValue(), id);
  };

  _proto.render = function render() {
    var _this$props3 = this.props,
        datum = _this$props3.datum,
        id = _this$props3.id;
    var checked = datum.getChecked(id);
    return _react.default.createElement(_Checkbox.default, {
      checked: checked,
      disabled: this.checkDisabled(),
      onChange: this.handleChange,
      className: (0, _styles.treeClass)('checkbox')
    });
  };

  return _default;
}(_component.PureComponent);

exports.default = _default;

_defineProperty(_default, "propTypes", {
  datum: _propTypes.default.object.isRequired,
  disabled: _propTypes.default.bool,
  id: _propTypes.default.string.isRequired,
  onChange: _propTypes.default.func.isRequired
});